import { FetchListFilterOptions } from '~/api/_types';
import { AppTablePagination } from '~/components/base/tables/_types';
import { fetchPrograms } from '~/services/programs';

export default (initialPagination?: AppTablePagination | null, implicitFilter?: FetchListFilterOptions[] | null) =>
    useApiCollectionData(fetchPrograms, initialPagination, implicitFilter);
